import { render, staticRenderFns } from "./rkpd_program.vue?vue&type=template&id=b561b9c0&"
import script from "./rkpd_program.vue?vue&type=script&lang=js&"
export * from "./rkpd_program.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports